<template>
  <div class="video-slider">
    <header class="video-slider__header">
      <h3 class="video-slider__title">
        {{ $t('video.all') }} <span>{{ videos.length }}</span>
      </h3>
      <div class="video-slider__navigation">
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </div>
    </header>
    <swiper class="swiper" :options="swiperOption" ref="swiper">
      <swiper-slide class="swiper-item" v-for="(video, i) in videos" :key="i">
        <div class="video-item" :class="{ 'active': videoIndex === i }" @click="CHANGE_CURRENT_VIDEO_INFO(video)">
          <img
            class="swiper-lazy video-item__img"
            loading="lazy"
            data-force-load="true"
            :src="`https://img.youtube.com/vi/${video.video_id}/sddefault.jpg`"
            alt="youtube-img"
          />
          <div class="video-item__play-button"></div>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  name: 'VideoSlider',
  components: {
    Swiper,
    SwiperSlide
  },
  props: {
    videos: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapState({
      videoIndex: state => state.videoGallery.currentVideoInfo.video_index
    })
  },
  methods: {
    ...mapActions(['CHANGE_CURRENT_VIDEO_INFO'])
  },
  data () {
    return {
      swiperOption: {
        spaceBetween: 10,
        slidesPerView: 1.5,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        preloadImages: false,
        lazy: true,
        breakpoints: {
          768: {
            slidesPerView: 3
          }
        }
      }
    }
  }
}
</script>

<style scoped lang="sass">

.video-slider
  margin: 40px -15px
  padding: 30px 0
  background-color: #f8f8f8

  +mmin($tablet)
    margin: 40px 0 0 0
    padding: 30px

.swiper
  padding: 0 15px

  +mmin($tablet)
    padding: 0

.video-slider__header
  display: flex
  flex-flow: row nowrap
  justify-content: space-between
  align-items: center
  margin-bottom: 30px
  padding: 0 15px

  +mmin($tablet)
    padding: 0

.video-slider__title
  font-size: 18px
  font-weight: 400
  margin: 0
  padding: 0

  span
    color: #ccc

.video-slider__navigation
  position: relative
  width: 70px

  .swiper-button-next,
  .swiper-button-prev
    color: $text-color
    z-index: 2

    &:after
      font-size: 18px

  .swiper-button-next
    right: 0

  .swiper-button-prev
    left: 0

.video-item
  background-color: transparent
  position: relative
  overflow: hidden
  cursor: pointer
  padding-bottom: 56.25%
  height: 0
  border: 10px solid transparent
  border-radius: 3px

  &:hover
    border-color: #ccc

  &__img
    width: 100%
    cursor: pointer
    object-fit: contain

    +mmin($extsmall)
      position: absolute
      top: -16.75%

  &__play-button
    width: 44px
    height: 44px
    background-color: $main-color
    box-shadow: 0 0 30px rgba( 0,0,0,0.6 )
    z-index: 1
    border-radius: 50%
    cursor: pointer
    position: absolute
    top: 50%
    left: 50%
    transform: translate3d( -50%, -50%, 0 )
    transition: all .3s

    &:hover
      background-color: $text-color
      opacity: .8

    &::before
      content: ""
      position: absolute
      border-style: solid
      border-width: 7px 0 7px 13px
      border-color: transparent transparent transparent #fff
      top: 50%
      left: 50%
      transform: translate3d( -40%, -50%, 0 )

.video-item.active
  border-color: #4c4c4c

  .video-item__play-button
    display: none
</style>
